import { Controller } from "@hotwired/stimulus"

// Popover a margine: uno solo aperto alla volta, Esc o click fuori chiude.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this._onDocumentClick = (event) => {
      if (!this.element.contains(event.target)) this.close()
    }
    this._onKeydown = (event) => {
      if (event.key === "Escape") this.close()
    }
  }

  toggle() {
    this.panelTarget.classList.contains("hidden") ? this.open() : this.close()
  }

  open() {
    document.querySelectorAll("[data-controller~='popover'] [data-popover-target='panel']")
      .forEach((panel) => panel.classList.add("hidden"))
    this.panelTarget.classList.remove("hidden")
    document.addEventListener("click", this._onDocumentClick, true)
    document.addEventListener("keydown", this._onKeydown)
  }

  close() {
    this.panelTarget.classList.add("hidden")
    document.removeEventListener("click", this._onDocumentClick, true)
    document.removeEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    this.close()
  }
}
